import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import PaymentStatus from "../components/PaymentStatus";
import XenditAPI from "../api/XenditAPI";

export default function PaymentStatusPage() {
    const navigate = useNavigate();
    const { refNo, status } = useParams();
    const [validated, setValidated] = useState(false);

    useEffect(() => {
        const validateURL = async () => {
            if (refNo) {
                const res = await XenditAPI.validate(refNo);
                if (res) {
                    setValidated(true);
                    return;
                }
            }
            navigate('/') //handle invalid URL
        }
        validateURL();
    }, [])

    return (
        <>
            {validated && <PaymentStatus status={status} />}
        </>
    )
}